import React from "react"
import ImageMarkerFeatureComponent from "../../../../../components/FeaturesComponents/modules/checklist/image-marker/ImageMarkerFeatureComponent"
import RepeaterFeatureComponent
  from "../../../../../components/FeaturesComponents/modules/checklist/repeater/RepeaterFeatureComponent"

const featuresArr = {
  issues: {
    key: 'act_create_issue',
    title: `actions.nav.issues`
  }
}

export default featuresArr
